var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreHoriz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7410_88724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00008 6.66666C3.26675 6.66666 2.66675 7.26666 2.66675 7.99999C2.66675 8.73332 3.26675 9.33332 4.00008 9.33332C4.73341 9.33332 5.33341 8.73332 5.33341 7.99999C5.33341 7.26666 4.73341 6.66666 4.00008 6.66666ZM12.0001 6.66666C11.2667 6.66666 10.6667 7.26666 10.6667 7.99999C10.6667 8.73332 11.2667 9.33332 12.0001 9.33332C12.7334 9.33332 13.3334 8.73332 13.3334 7.99999C13.3334 7.26666 12.7334 6.66666 12.0001 6.66666ZM8.00008 6.66666C7.26675 6.66666 6.66675 7.26666 6.66675 7.99999C6.66675 8.73332 7.26675 9.33332 8.00008 9.33332C8.73341 9.33332 9.33341 8.73332 9.33341 7.99999C9.33341 7.26666 8.73341 6.66666 8.00008 6.66666Z",
    fill: "#53646C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7410_88724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHoriz);
export default __webpack_public_path__ + "static/media/more_horiz.0d0e8c36a7f5dccf99ef1297190cca36.svg";
export { ForwardRef as ReactComponent };